import VNode from '../utils/vnode';

export default new VNode({
  type: 'div',
  content: 'H5JSSDK 账号登录',
  attrs: {
    class: 'login-header'
  },
  styles: {
    margin: '-10px',
    padding: '18px',
    background: '#000',
    color: '#fff',
    borderRadius: '6px 6px 0 0',
    fontSize: '14px',
    fontWeight: 'bold'
  },
});